<app-login-payment [showGuestRegister]="false" (eventLoggedIn)="onLoggedIn()" (eventRegister)="register()"
  [showRegistrationUrl]="allowedRegistration" [showRememberMe]="showRememberMe"></app-login-payment>
